import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import BreadCrumbViewModelType from '@/ViewModels/Controls/BreadCrumbViewModel';
import LabelType from '@/Controls/Label';

export default class BreadCrumb extends Control {

    private Label = ComponentManager.getControl<typeof LabelType>('Label');
    private jQueryControl: JQuery;

    public constructor(private viewModel: BreadCrumbViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'breadcrumb',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible,

            breadcrumbElements: {
                parent: this,

                elements: this.viewModel.elements
            },

            styles: this.definePureComputed({
                read: () => {
                    let styles = [];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isActive() === true) {
                        states.push('active');
                    }

                    return states;
                }
            })
        });
    }
}

ComponentManager.setControl('BreadCrumb', BreadCrumb, 'RADPresentation.HTMLClient.DefaultViewExtensions');